export const SelectForm = ({
  label,
  sublabel,
  options,
  labelKey,
  validation,
  submit,
  name,
  value,
  onInputChange,
  disabled,
}) => {
  return (
    <div className="vstack">
      <label className="form-label text-gray-600 mb-0">
        {label} <span className="text-gray-300 fs-sm">{sublabel}</span>
      </label>
      <select
        className={`form-select form-control ${
          validation && submit && "border-danger"
        }`}
        name={name}
        value={value}
        onChange={onInputChange}
        disabled={disabled}
      >
        <option value={""} disabled={true}>
          Seleccionar
        </option>
        {options.map((option) => (
          <option key={option.id} value={option.id}>
            {option[labelKey]}
          </option>
        ))}
      </select>
      {validation && submit && (
        <span className="text-danger">{validation}</span>
      )}
    </div>
  );
};
